import { PropsWithChildren } from 'react'

import { form } from '../../../../../../../formState'

type EligibilityVisibilityHandlerProps = PropsWithChildren<{
  isSimulation: boolean
  recurrenceSettingsFieldName: 'recurrenceSettings'
}>

export function EligibilityVisibilityHandler(props: EligibilityVisibilityHandlerProps) {
  const { isSimulation, children, recurrenceSettingsFieldName } = props

  const recurrenceSettingsField = form.useFormField(recurrenceSettingsFieldName)
  const value = recurrenceSettingsField.field.value

  const isRecurrenceEnabled = value?.recurrencePeriod.recurrenceType === 'NO_REPEAT' || isSimulation

  return isRecurrenceEnabled ? children : null
}
